import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { StyledButton } from "./style";

export interface ButtonArrowProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  name: string;
  style?: React.CSSProperties;
  height?: number;
  fontSize?: number;
  isClose?: boolean;
}

const ButtonArrowDown = ({
  onClick,
  className,
  disabled,
  loading,
  name,
  fontSize,
  height,
  style,
  isClose,
}: ButtonArrowProps) => {
  return (
    <StyledButton
      loading={loading}
      disabled={disabled}
      className={className}
      onClick={onClick}
      size="small"
      $fontSize={fontSize}
      $height={height}
      style={{ ...style }}
    >
      <div className="button-arrow-down-name">
        {name}
        {isClose ? <FaChevronUp /> : <FaChevronDown />}
      </div>
    </StyledButton>
  );
};
export default ButtonArrowDown;
